import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Divider, Row } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import Button from 'components/generalUI/Button';
import LoadingModal from 'components/generalUI/LoadingModal';
import PurchaseSteps from 'components/generalUI/PurchaseSteps';
import PurchaseSummaryCard from 'components/TicketSummary/PurchaseSummaryCard';
import ContactForm from 'components/TicketSummary/ContactForm';
import PurchaseConfirmation from 'components/TicketSummary/PurchaseConfirmation';
import DiscountCard from 'components/TicketSummary/DiscountCard';
import AdditionalServicesCard from 'components/TicketSummary/AdditionalServicesCard';
import useTicketSummaryViewModel from './ticketSummary.viewModel';
import styles from './TicketSummary.module.scss';

const TicketSummary: FC = () => {
  const { t } = useTranslation();
  const viewModel = useTicketSummaryViewModel();

  return (
    <div className={styles.Container}>
      <LoadingModal visible={viewModel.loading} />

      <div className={styles.Header}>
        <Button kind="secondary" className={styles.BackButton} onClick={viewModel.goBack}>
          <LeftOutlined />
          {t('pages.ticketSummary.goBack')}
        </Button>
        <PurchaseSteps total={4} current={2} />
      </div>

      <h1 className={styles.Title}>{t('pages.ticketSummary.title')}</h1>

      {viewModel.visitDate && <h2 className={styles.VisitDate}>{viewModel.visitDate}</h2>}

      <Row justify="center" gutter={[40, 24]} className={styles.Content}>
        <Col xs={22} lg={14}>
          <div className={styles.LeftCard}>
            <ContactForm
              form={viewModel.form}
              onValuesChange={viewModel.onValuesChange}
              onIncompleteSubmit={viewModel.onIncompleteSubmit}
              onFinish={viewModel.onFinish}
            />
            {viewModel.showConfirmation && (
              <>
                <Divider className={styles.CardDivider} />
                <PurchaseConfirmation {...viewModel.confirmation} />
              </>
            )}
          </div>
        </Col>
        <Col xs={22} lg={10}>
          <div className={styles.RightColumn}>
            <DiscountCard {...viewModel.discountCard} />
            <AdditionalServicesCard {...viewModel.additionalServices} />
            <PurchaseSummaryCard {...viewModel} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TicketSummary;
